import "./application.scss";
import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap";
import { Application } from "@hotwired/stimulus";
import { registerControllers } from "stimulus-vite-helpers";

window.bootstrap = bootstrap;

const application = Application.start();
application.debug = false;
window.Stimulus = application;

const controllers = import.meta.glob("../controllers/**/*.js", { eager: true });
registerControllers(application, controllers);
